<template>
  <div style="margin-top: 40%">
    <nut-row>
      <nut-col :span="24">
        <div class="flex-content" v-if="!fastLoginType">
          <img src="https://cdn.qingbeiyuan.cn/39672ee0-4597-1eff-082f-c948d0b2544e.png" style="width: 50px"/>
          <p style="padding-bottom: 10px">智学移动版</p>

          <div v-show="accountLoginType">
            <nut-col :span="24">
              <nut-input
                  class="login-input"
                  v-model="account"
                  :border="false"
                  placeholder="账号"/>
            </nut-col>
            <nut-col :span="24">
              <nut-input
                  class="login-input"
                  v-model="password"
                  :border="false"
                  type="password"
                  placeholder="密码"
              />
            </nut-col>
            <nut-col :span="12">
              <nut-input
                  class="login-input login-input-captcha"
                  v-model="captcha"
                  :border="false"
                  autocomplete="off"
                  placeholder="验证码"/>
            </nut-col>
            <nut-col :span="12">
              <nut-image :src="'/login/captcha/'+captchaToken+'/200/50'"
                         width="80%"
                         style="margin-left: 5%"
                         @click="refreshCaptcha"/>
            </nut-col>
            <nut-col :span="24">
              <nut-button type="info" style="width: 85%;margin-top: 10%" class="loginBtn" @click="passwordLogin">登录
              </nut-button>
            </nut-col>
          </div>
        </div>
      </nut-col>
    </nut-row>
  </div>
</template>


<script>
import {Dialog, Toast} from '@nutui/nutui';
import api from "@/api";
import {mapMutations} from "vuex";
import md5 from 'js-md5'

export default {
  name: "LoginView",
  data() {
    return {
      accountLoginType: false,
      account: '',
      password: '',
      captcha: '',
      fastLoginType: false,
      isWxEnv: false,
      captchaToken: '376233414898836402b069bdefault',
      wxBindToken: null,
    }
  },
  watch: {
    accountLoginType(b) {
      if (!b) {
        return
      }
      this.refreshCaptcha();
    }
  },
  methods: {
    ...mapMutations(['updateUser', 'updateEnv']),
    wxLogin() {
      Toast.loading('自动登录中...', {
        duration: 5000
      });
      let url = window.location.href;
      console.log('当前链接：',url)
      let code = this.$route.query.code;
      if (code) {
        api.wechatCodeLogin(code).then(ret => {
          Toast.hide();
          this.setAccessToken(ret.accessToken);
          this.loadUserInfo();
        });
      } else {
        api.getWechatRedirectUrl(url).then(ret => {
          window.location.href = ret;
        })
      }
    },
    passwordLogin() {
      if (!this.account || !this.password || !this.captcha) {
        Toast.warn('账号、密码、验证码都是必填项');
        return
      }
      Toast.loading('登录中...');
      api.login({
        phone: this.account,
        password: md5(this.password),
        captcha: this.captcha,
        token: this.captchaToken,
        channel: 1
      }).then(ret => {
        Toast.hide();
        this.setAccessToken(ret.accessToken);
        if (this.wxBindToken) {
          Dialog({
            title: '是否绑定该账号',
            content: '绑定后再次打开可免密登录',
            onCancel: () => {
              this.loadUserInfo();
            },
            onOk: () => {
              api.bindWechat(this.wxBindToken).then(() => {
                Toast.success("绑定成功!");
              });
              this.loadUserInfo();
            }
          });
        } else {
          this.loadUserInfo();
        }
      })
    },
    setAccessToken(accessToken) {
      localStorage.setItem('access_token', accessToken);
    },
    loadUserInfo() {
      api.getUserInfo().then(userInfo => {
        this.updateUser(userInfo);
        this.updateEnv(this.isWxEnv ? 'wechat' : 'h5');
        // 取到原页面路径
        let url = this.$route.query.redirect;
        // 跳转回原页面
        this.$router.push(decodeURIComponent(url ? url : '/'));
      })
    },
    refreshCaptcha() {
      api.getLoginCaptchaToken().then(ret => {
        this.captchaToken = ret;
      });
    }
  },
  mounted() {
    //检测快捷登录码
    // if (this.$route.query.accessToken) {
    //   Toast.loading('请稍等...', {
    //     duration: 500
    //   });
    //   this.fastLoginType = true;
    //   localStorage.setItem('access_token', this.$route.query.accessToken);
    //   this.$router.push("/");
    //   return;
    // }
    //环境检测
    // var userAgent = window.navigator.userAgent.toLowerCase();
    // console.log(userAgent);
    // if (userAgent.match(/MicroMessenger/i) == "micromessenger") {
      this.isWxEnv = true;
      this.wxLogin();
    // } else {
    //   //非自动化环境
    //   this.accountLoginType = true;
    // }
    // this.refreshCaptcha();
  }
}
</script>

<style lang="scss" scoped>
.loginBtn {
  font-size: $baseFontSize;
}

.login-input {
  border: 1px solid lightgray;
  width: 80%;
  margin-left: 10%;
  border-radius: 20px;
  padding: 5px 10px;
  margin-bottom: 10px;
  font-size: $baseFontSize;
}

.login-input-captcha {
  margin-left: auto;
}

.nut-row {
  overflow: hidden;

  &:not(:last-child) .nut-col {
    margin-bottom: 15px;
  }

  margin-bottom: 15px;
}

.flex-content {
  line-height: 40px;
  text-align: center;
  border: 0;
  font-size: $baseFontSize;

  p {
    padding: 0;
    margin: 0;
    line-height: 25px;
    font-size: $baseFontSize;
    color: #005FF5;
  }
}
</style>